import React, { Component } from 'react';
import utilFunction from '../../../containers/function'
import strings from '../../locales/';
import LineChart from '../graphs/crossfilterGraphs/lineChart';

const DailyBehaviorGradeGraph = (props) => (
  <div id="daily-behavior-grade-graph" className="dc-chart-parent">
    <LineChart 
      id={"daily-behavior-grade-graph-component"} 
      additionalCrossfilterData={null}
      crossfilerData={utilFunction.generateCrossfilter(props.data)}
      stack={false} 
      dimension={{
        formatFunction:[["parseDateUTC","%Y-%m-%dT%H:%M:%S.%L%Z"]],
        name:"date",
        originalName:"date",
        reduceFunction:{type: "CONTINUOUS_GROUP", typeof: "DATE_TIME"}
      }}
      metrics={[{
        config:{},
        filter: [],
        formatFunction: [],
        metric: "behaviorGrade",
        name: "behaviorGrade",
        reduceFunction: {type: "AVG"},
        type: "AVG"
      }]} 
      config={{
        "colorRange":[
          {"color":"#fae3e4","range":[{"value":props.graphColorRange.higherRisk[1],"operator":"<"}]},
          {"color":"#fdefd3","range":[{"value":props.graphColorRange.middleRisk[0],"operator":">="},{"value":props.graphColorRange.middleRisk[1],"operator":"<"}]},
          {"color":"#d5f3eb","range":[{"value":props.graphColorRange.outOfRisk[0],"operator":">="}]}
        ],
        "tooltip":{
          "valuesConfig":[
            {"identifier":"x","valueFormat":{"type":"DATE_TIME_UTC","format":"%d-%m-%Y"},"wrapper":"<div>%v</div>"},
            {"identifier":"y","valueFormat":{"type":"NUMBER","format":".0f"},"wrapper":`<div>${props.tooltip}: <span style='font-weight:bold;'>%v</span></div>`,"colorRange":[
              {"color":"#CC5660","range":[{"value":props.graphColorRange.higherRisk[1],"operator":"<"}]},
              {"color":"#F3B119","range":[{"value":props.graphColorRange.middleRisk[0],"operator":">="},{"value":props.graphColorRange.middleRisk[1],"operator":"<"}]},
              {"color":"#41C99F","range":[{"value":props.graphColorRange.outOfRisk[0],"operator":">="}]}
            ]}
        ]},
        "renderArea":false,
        "interpolation":"linear",
        "stroke":2.4,
        "colors":["#aeb2b1"],
        "dataPoints":{"show":true,"radius":3},
        "xAxis":{"show":true,"interval":5,"intervalDateUnit":"DAY","format":"%d-%m","rotation":0},
        "yAxis":{"show":true,"horizontalLines":false,"ticksNumber":2,"format":".0f","autoRange":{"active":false,"max":100,"min":0}}
      }}
      dashboardId={"detail_behavior"}
    />
  </div>
);
  
export default DailyBehaviorGradeGraph;


// WEBPACK FOOTER //
// ./source/client/components/common/behavior/dailyBehaviorGradeGraph.jsx